function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var TweetTemplate = require('./tweet.template');
var SaitoLinkPreview = require('../../../lib/saito/ui/saito-link-preview/saito-link-preview');
var SaitoLinkPreviewTemplate = require('../../../lib/saito/ui/saito-link-preview/saito-link-preview.template');
var Transaction = require('../../../lib/saito/transaction')["default"];
function returnMessage(tx) {
  if (tx && typeof tx.returnMessage === 'function') {
    return tx.returnMessage();
  }
  return tx && tx.msg && _typeof(tx.msg) === 'object' ? tx.msg : {};
}
function authorFromPublicKey(app, publicKey) {
  if (!publicKey) {
    return {
      username: 'anon',
      handle: '',
      avatar: '/saito/img/dreamscape.png'
    };
  }

  // Display name from keychain (registered identifier or Anon-xxxxxx).
  // Meta/handle storage is the raw public key — never an @username, never duplicate the name.
  var username = app.keychain.returnUsername(publicKey) || "Anon-".concat(publicKey.slice(0, 6));
  var handle = publicKey;
  var avatar = app.keychain.returnIdenticon(publicKey) || '/saito/img/dreamscape.png';
  return {
    username: username,
    handle: handle,
    avatar: avatar
  };
}
var Tweet = /*#__PURE__*/function () {
  function Tweet(app, mod, tx) {
    _classCallCheck(this, Tweet);
    this.app = app;
    this.mod = mod;
    this.container = '';
    this.tx = tx || null;
    this.signature = '';
    this.parent_id = '';
    this.thread_id = '';
    this.publicKey = '';
    this.username = 'anon';
    this.handle = 'anon';
    this.avatar = '/saito/img/dreamscape.png';
    this.created_at = Date.now();
    this.updated_at = this.created_at;
    this.text = '';
    this.images = [];
    this.embedded = null;
    this.link = '';
    this.link_properties = null;
    this.youtube_id = null;
    this.likes = 0;
    this.replies = 0;
    this.retweets = 0;
    this.flagged = 0;
    this.moderated = false;
    this.moderated_revealed = false;
    this.is_reply = false;
    this.critical_child = null;
    this.time = '';
    this.likers = [];
    this.repliers = [];
    this.retweeters = [];
    this.ephemeral = false;
    this.href = '';
    if (this.tx) {
      this.parseFromTransaction();
    }
  }
  return _createClass(Tweet, [{
    key: "updateFromTransaction",
    value: function updateFromTransaction(tx) {
      var _this$tx;
      var previousOptional = this.tx && this.tx.optional && _typeof(this.tx.optional) === 'object' ? this.tx.optional : {};
      var previousLikes = Number(this.likes) || Number(previousOptional.num_likes) || 0;
      var previousReplies = Number(this.replies) || Number(previousOptional.num_replies) || 0;
      var previousRetweets = Number(this.retweets) || Number(previousOptional.num_retweets) || 0;
      var previousRepliers = this.repliers.slice();
      var previousLikers = Array.isArray(previousOptional.likers) ? previousOptional.likers.slice() : Array.isArray(this.likers) ? this.likers.slice() : [];
      var previousRetweeters = Array.isArray(previousOptional.retweeters) ? previousOptional.retweeters.slice() : Array.isArray(this.retweeters) ? this.retweeters.slice() : [];
      var previousRetweetedAt = Number(previousOptional.retweeted_at) || 0;
      var previousUpdatedAt = Number(this.updated_at) || Number(previousOptional.updated_at) || Number((_this$tx = this.tx) === null || _this$tx === void 0 ? void 0 : _this$tx.timestamp) || 0;
      this.tx = tx || this.tx;
      this.parseFromTransaction();
      if (!this.tx.optional || _typeof(this.tx.optional) !== 'object') {
        this.tx.optional = {};
      }
      var incomingOptional = this.tx.optional;
      var incomingLikers = Array.isArray(incomingOptional.likers) ? incomingOptional.likers : [];
      this.tx.optional.likers = Array.from(new Set([].concat(_toConsumableArray(incomingLikers), _toConsumableArray(previousLikers))));
      var incomingRepliers = Array.isArray(incomingOptional.repliers) ? incomingOptional.repliers : [];
      this.tx.optional.repliers = Array.from(new Set([].concat(_toConsumableArray(incomingRepliers), _toConsumableArray(previousRepliers))));
      this.tx.optional.num_replies = Math.max(previousReplies, Number(incomingOptional.num_replies) || 0);
      this.tx.optional.num_likes = Math.max(previousLikes, Number(incomingOptional.num_likes) || 0, this.tx.optional.likers.length);
      this.tx.optional.num_retweets = Math.max(previousRetweets, Number(incomingOptional.num_retweets) || 0);
      this.replies = this.tx.optional.num_replies;
      this.likes = this.tx.optional.num_likes;
      this.retweets = this.tx.optional.num_retweets;
      this.likers = this.tx.optional.likers.slice();
      this.repliers = this.tx.optional.repliers.slice();
      if (Number(incomingOptional.num_retweets) > previousRetweets) {
        if (Array.isArray(incomingOptional.retweeters)) {
          this.tx.optional.retweeters = incomingOptional.retweeters.slice();
        }
        if (incomingOptional.retweeted_at != null) {
          this.tx.optional.retweeted_at = incomingOptional.retweeted_at;
        }
      } else if (previousRetweets > Number(incomingOptional.num_retweets) || 0) {
        this.tx.optional.retweeters = previousRetweeters.slice();
        if (previousRetweetedAt > 0) {
          this.tx.optional.retweeted_at = previousOptional.retweeted_at;
        }
      } else {
        var incomingRetweeters = Array.isArray(incomingOptional.retweeters) ? incomingOptional.retweeters : [];
        this.tx.optional.retweeters = incomingRetweeters.length >= previousRetweeters.length ? incomingRetweeters.slice() : previousRetweeters.slice();
        var incomingRetweetedAt = Number(incomingOptional.retweeted_at) || 0;
        if (incomingRetweetedAt >= previousRetweetedAt && incomingRetweetedAt > 0) {
          this.tx.optional.retweeted_at = incomingOptional.retweeted_at;
        } else if (previousRetweetedAt > 0) {
          this.tx.optional.retweeted_at = previousOptional.retweeted_at;
        }
      }
      this.retweeters = Array.isArray(this.tx.optional.retweeters) ? this.tx.optional.retweeters.slice() : [];
      var mergedUpdatedAt = Math.max(previousUpdatedAt, Number(incomingOptional.updated_at) || Number(this.updated_at) || 0);
      if (mergedUpdatedAt > 0) {
        this.tx.optional.updated_at = mergedUpdatedAt;
        this.updated_at = mergedUpdatedAt;
      }
      var statsChanged = this.likes !== previousLikes || this.replies !== previousReplies || this.retweets !== previousRetweets || this.repliers.includes(this.mod.publicKey) !== previousRepliers.includes(this.mod.publicKey) || this.likers.includes(this.mod.publicKey) !== previousLikers.includes(this.mod.publicKey) || this.retweeters.includes(this.mod.publicKey) !== previousRetweeters.includes(this.mod.publicKey);
      if (statsChanged) {
        this.refreshControls();
      }
    }
  }, {
    key: "parseFromTransaction",
    value: function parseFromTransaction() {
      var txmsg = returnMessage(this.tx);
      var data = txmsg.data && _typeof(txmsg.data) === 'object' ? txmsg.data : {};
      var optional = this.tx.optional && _typeof(this.tx.optional) === 'object' ? this.tx.optional : {};
      this.signature = this.tx.signature != null ? String(this.tx.signature) : '';
      this.text = data.text != null ? String(data.text) : '';
      this.parent_id = data.parent_id != null ? String(data.parent_id) : '';
      this.thread_id = data.thread_id != null && String(data.thread_id) !== '' ? String(data.thread_id) : this.signature;
      this.link = data.link != null && String(data.link).trim() !== '' ? String(data.link).trim() : '';
      this.ephemeral = Boolean(data.ephemeral);
      this.href = data.href != null && String(data.href).trim() !== '' ? String(data.href).trim() : '';
      this.link_properties = optional.link_properties && _typeof(optional.link_properties) === 'object' ? optional.link_properties : null;
      this.youtube_id = null;
      this.analyseTweetLinks(false);
      var images = data.images;
      this.images = Array.isArray(images) ? images.slice() : images ? [images] : [];
      this.embedded = this.normalizeEmbedded(data.embedded);
      this.created_at = Number(this.tx.timestamp) || Date.now();
      this.updated_at = Number(optional.updated_at) || Number(optional.edit_ts) || this.created_at;
      this.applyEditFromOptional();
      this.likes = Number(optional.num_likes) || 0;
      this.replies = Number(optional.num_replies) || 0;
      this.retweets = Number(optional.num_retweets) || 0;
      this.likers = Array.isArray(optional.likers) ? optional.likers.slice() : [];
      this.repliers = Array.isArray(optional.repliers) ? optional.repliers.slice() : [];
      this.retweeters = Array.isArray(optional.retweeters) ? optional.retweeters.slice() : [];
      this.flagged = Number(optional.flagged) || 0;
      this.is_reply = this.parent_id !== '';
      this.publicKey = this.extractPublicKey();
      var author = authorFromPublicKey(this.app, this.publicKey);
      this.username = author.username;
      this.handle = author.handle;
      this.avatar = author.avatar;
      this.time = this.app.browser.formatRelativeTime(this.created_at);
    }
  }, {
    key: "extractPublicKey",
    value: function extractPublicKey() {
      if (this.tx && this.tx.from && this.tx.from[0] && this.tx.from[0].publicKey) {
        return String(this.tx.from[0].publicKey);
      }
      return '';
    }
  }, {
    key: "normalizeEmbedded",
    value: function normalizeEmbedded(raw) {
      if (!raw || _typeof(raw) !== 'object') {
        return null;
      }
      if (raw instanceof Tweet) {
        return raw;
      }
      var created_at = Number(raw.created_at) || Date.now();
      var publicKey = raw.publicKey != null ? String(raw.publicKey) : '';
      var author = authorFromPublicKey(this.app, publicKey);
      var embedded = {
        signature: raw.signature != null ? String(raw.signature) : '',
        publicKey: publicKey,
        username: raw.username != null ? String(raw.username) : author.username,
        handle: raw.handle != null ? String(raw.handle) : author.handle,
        avatar: raw.avatar != null ? String(raw.avatar) : author.avatar,
        created_at: created_at,
        text: raw.text != null ? String(raw.text) : '',
        images: Array.isArray(raw.images) ? raw.images.slice(0, 4) : [],
        embedded: null,
        likes: Number(raw.likes) || 0,
        replies: Number(raw.replies) || 0,
        retweets: Number(raw.retweets) || 0,
        time: raw.time != null ? String(raw.time) : this.app.browser.formatRelativeTime(created_at)
      };
      return embedded;
    }
  }, {
    key: "hasLinkPreview",
    value: function hasLinkPreview() {
      var props = this.link_properties;
      if (!props || _typeof(props) !== 'object' || this.youtube_id) {
        return false;
      }
      return Boolean(props['og:title'] || props['og:description'] || props['og:image'] || props['saito:title'] || props['saito:description']);
    }
  }, {
    key: "renderLinkPreviewHTML",
    value: function renderLinkPreviewHTML() {
      if (!this.app.BROWSER || !this.link || !this.hasLinkPreview()) {
        return '';
      }
      try {
        var preview = new SaitoLinkPreview(this.app, this.mod, '', this.link, this.link_properties);
        return "<div class=\"link-preview\">".concat(SaitoLinkPreviewTemplate(preview), "</div>");
      } catch (err) {
        console.warn('RedSquare link preview render skipped', (err === null || err === void 0 ? void 0 : err.message) || err);
        return '';
      }
    }
  }, {
    key: "extractYoutubeId",
    value: function extractYoutubeId(link) {
      if (!link || link.indexOf('youtube.com') === -1 && link.indexOf('youtu.be') === -1) {
        return null;
      }
      var videoId = '';
      if (link.indexOf('youtu.be') !== -1) {
        var parts = link.split('/');
        videoId = parts[parts.length - 1] || '';
      } else {
        try {
          var url = new URL(link);
          videoId = url.searchParams.get('v') || '';
        } catch (err) {
          videoId = '';
        }
      }
      var shorts = link.split('/shorts/');
      if (typeof shorts[1] !== 'undefined') {
        videoId = shorts[1];
      }
      var live = link.split('/live/');
      if (typeof live[1] !== 'undefined') {
        videoId = live[1];
      }
      videoId = String(videoId || '').split(/[?&#]/)[0].replace(/[^a-zA-Z0-9_-]/g, '');
      if (!videoId || videoId === 'null') {
        return null;
      }
      return videoId;
    }
  }, {
    key: "analyseTweetLinks",
    value: function () {
      var _analyseTweetLinks = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var fetch_open_graph,
          res,
          _args = arguments,
          _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              fetch_open_graph = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;
              if (!this.link && this.text) {
                this.link = this.app.browser.extractFirstValidURL(this.text) || '';
              }
              if (this.link) {
                _context.n = 1;
                break;
              }
              return _context.a(2, this);
            case 1:
              this.youtube_id = this.extractYoutubeId(this.link);
              if (!this.youtube_id) {
                _context.n = 2;
                break;
              }
              return _context.a(2, this);
            case 2:
              if (!(this.app.BROWSER || !fetch_open_graph)) {
                _context.n = 3;
                break;
              }
              return _context.a(2, this);
            case 3:
              if (!this.hasLinkPreview()) {
                _context.n = 4;
                break;
              }
              return _context.a(2, this);
            case 4:
              _context.p = 4;
              _context.n = 5;
              return this.app.server.fetchOpenGraphProperties(this.link);
            case 5:
              res = _context.v;
              if (res && _typeof(res) === 'object') {
                if (!this.tx.optional || _typeof(this.tx.optional) !== 'object') {
                  this.tx.optional = {};
                }
                this.tx.optional.link_properties = res;
                this.link_properties = res;
              }
              _context.n = 7;
              break;
            case 6:
              _context.p = 6;
              _t = _context.v;
              console.warn('RedSquare Open Graph fetch failed', (_t === null || _t === void 0 ? void 0 : _t.message) || _t);
            case 7:
              return _context.a(2, this);
          }
        }, _callee, this, [[4, 6]]);
      }));
      function analyseTweetLinks() {
        return _analyseTweetLinks.apply(this, arguments);
      }
      return analyseTweetLinks;
    }()
  }, {
    key: "renderHTML",
    value: function renderHTML() {
      var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'tweet';
      return TweetTemplate(this, className);
    }
  }, {
    key: "buildClassName",
    value: function buildClassName() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var presentation = options.presentation || (options.embedded ? 'embedded' : options.focused ? 'focused' : options.root ? 'root' : options.reply ? 'reply' : 'timeline');

      // Default timeline presentation has no modifier — root is just `.tweet`.
      var classes = ['tweet'];
      if (presentation && presentation !== 'timeline') {
        classes.push(presentation);
      }
      if (options.focused && presentation !== 'focused') {
        classes.push('focused');
      }
      if (options.chainPrev) {
        classes.push('chain-prev');
      }
      if (options.chainNext) {
        classes.push('chain-next');
      }
      if (options.chainContinue) {
        classes.push('chain-continue');
      }
      if (this.showsModerationMask()) {
        classes.push('moderated');
      }
      return classes.join(' ');
    }
  }, {
    key: "showsModerationMask",
    value: function showsModerationMask() {
      return Boolean(this.flagged === 1) || Boolean(this.moderated && !this.moderated_revealed);
    }

    /**
     * Replace already-rendered tweet nodes in place (no timeline rebuild).
     */
  }, {
    key: "refresh",
    value: function refresh() {
      if (!this.app.BROWSER || !this.signature) {
        return;
      }
      var nodes = document.querySelectorAll("article.tweet[data-id=\"".concat(this.signature, "\"]"));
      if (!nodes.length) {
        return;
      }
      var _iterator = _createForOfIteratorHelper(nodes),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var el = _step.value;
          var className = this.syncModeratedClassName(el.className || 'tweet');
          var html = TweetTemplate(this, className, {
            presentation: this.presentationFromClassName(className),
            embedded: /\bembedded\b/.test(className),
            focused: /\bfocused\b/.test(className),
            root: /\broot\b/.test(className),
            reply: /\breply\b/.test(className),
            chainPrev: /\bchain-prev\b/.test(className),
            chainNext: /\bchain-next\b/.test(className),
            chainContinue: /\bchain-continue\b/.test(className)
          });
          el.outerHTML = html;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.attachModerationEvents();
    }
  }, {
    key: "applyEditFromOptional",
    value: function applyEditFromOptional() {
      var _this$tx2;
      var update_tx = (_this$tx2 = this.tx) === null || _this$tx2 === void 0 || (_this$tx2 = _this$tx2.optional) === null || _this$tx2 === void 0 ? void 0 : _this$tx2.update_tx;
      if (!update_tx) {
        return;
      }
      try {
        var _editMsg$data;
        var editTx = new Transaction();
        editTx.deserialize_from_web(this.app, update_tx);
        var editMsg = returnMessage(editTx);
        if ((editMsg === null || editMsg === void 0 || (_editMsg$data = editMsg.data) === null || _editMsg$data === void 0 ? void 0 : _editMsg$data.text) != null) {
          this.text = String(editMsg.data.text);
        }
        this.updated_at = Number(this.tx.optional.edit_ts) || Number(editTx.timestamp) || this.updated_at;
      } catch (err) {
        console.error('RedSquare failed to apply tweet edit:', err);
      }
    }
  }, {
    key: "removeFromDom",
    value: function removeFromDom() {
      if (!this.app.BROWSER || !this.signature) {
        return;
      }
      document.querySelectorAll("article.tweet[data-id=\"".concat(this.signature, "\"]")).forEach(function (el) {
        return el.remove();
      });
    }
  }, {
    key: "syncModeratedClassName",
    value: function syncModeratedClassName() {
      var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'tweet';
      var classes = new Set(String(className).split(/\s+/).filter(Boolean));
      classes.add('tweet');
      if (this.showsModerationMask()) {
        classes.add('moderated');
      } else {
        classes["delete"]('moderated');
      }
      return Array.from(classes).join(' ');
    }
  }, {
    key: "presentationFromClassName",
    value: function presentationFromClassName() {
      var className = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (/\bembedded\b/.test(className)) {
        return 'embedded';
      }
      if (/\bfocused\b/.test(className)) {
        return 'focused';
      }
      if (/\broot\b/.test(className)) {
        return 'root';
      }
      if (/\breply\b/.test(className)) {
        return 'reply';
      }
      return 'timeline';
    }
  }, {
    key: "attachModerationEvents",
    value: function attachModerationEvents() {
      var _this = this;
      if (!this.app.BROWSER || !this.signature || this.flagged === 1 || !this.showsModerationMask()) {
        return;
      }
      var buttons = document.querySelectorAll("article.tweet[data-id=\"".concat(this.signature, "\"] .show-tweet"));
      var _iterator2 = _createForOfIteratorHelper(buttons),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var button = _step2.value;
          button.onclick = function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this.moderated_revealed = true;
            _this.refresh();
          };
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "incrementStat",
    value: function incrementStat(field) {
      var optionalKey = field === 'likes' ? 'num_likes' : field === 'retweets' ? 'num_retweets' : 'num_replies';
      if (!this.tx) {
        return this;
      }
      if (!this.tx.optional || _typeof(this.tx.optional) !== 'object') {
        this.tx.optional = {};
      }
      var current = Number(this[field]) || Number(this.tx.optional[optionalKey]) || 0;
      var next = current + 1;
      this[field] = next;
      this.tx.optional[optionalKey] = next;
      return this;
    }
  }, {
    key: "hasReplied",
    value: function hasReplied() {
      var _this$mod$tweets_chil,
        _this2 = this;
      var publicKey = this.mod.publicKey;
      if (!publicKey) {
        return false;
      }

      // Older tweets may have loaded replies but no archived replier list yet.
      return this.repliers.includes(publicKey) || (((_this$mod$tweets_chil = this.mod.tweets_children) === null || _this$mod$tweets_chil === void 0 ? void 0 : _this$mod$tweets_chil[this.signature]) || []).some(function (signature) {
        var _this2$mod$getTweet;
        return ((_this2$mod$getTweet = _this2.mod.getTweet(signature)) === null || _this2$mod$getTweet === void 0 ? void 0 : _this2$mod$getTweet.publicKey) === publicKey;
      });
    }
  }, {
    key: "refreshControls",
    value: function refreshControls() {
      if (!this.app.BROWSER || !this.signature) {
        return;
      }
      var selectors = [['comment', this.replies, 'replied', this.hasReplied()], ['like', this.likes, 'liked', Boolean(this.mod.publicKey && this.likers.includes(this.mod.publicKey))], ['retweet', this.retweets, 'retweeted', Boolean(this.mod.publicKey && this.retweeters.includes(this.mod.publicKey))]];
      for (var _i = 0, _selectors = selectors; _i < _selectors.length; _i++) {
        var _selectors$_i = _slicedToArray(_selectors[_i], 4),
          tool = _selectors$_i[0],
          count = _selectors$_i[1],
          state = _selectors$_i[2],
          active = _selectors$_i[3];
        var nodes = document.querySelectorAll("article.tweet[data-id=\"".concat(this.signature, "\"] .tool.").concat(tool, " .count"));
        var _iterator3 = _createForOfIteratorHelper(nodes),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var node = _step3.value;
            node.textContent = String(count);
            node.closest('.tool').classList.toggle(state, active);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (container) {
        this.container = container;
      }
      var className = this.buildClassName(options);
      this.app.browser.addElementToSelector(TweetTemplate(this, className, _objectSpread(_objectSpread({}, options), {}, {
        presentation: options.presentation || (options.embedded ? 'embedded' : options.focused ? 'focused' : options.root ? 'root' : options.reply ? 'reply' : 'timeline')
      })), this.container);
      this.attachModerationEvents();
    }
  }]);
}();
module.exports = Tweet;